export default __webpack_public_path__ + "static/media/v2_278.199c704c.png";